<template>
  <div>
    <div>
      <div class="dialog-form-item">
        <el-form label-width="150px" >
            <el-form-item prep="type" ref="type">
              <div slot="label" style="text-align:left"><span v-t="'message.item_batch_export_type'"></span></div>
              <el-select
                v-model="selectedType" 
                :disabled=isSelecterDisable>
                <el-option v-for="type in typeItems" :key="type.name" :label="type.label" :value="type.name"></el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="batchState===NO_QUEUE" v-html="$t('message.info_batch_export_enable_request')"></div>
      <div v-else-if="batchState===IN_QUEUE">
        {{ $t('message.info_batch_export_in_request', { name: displayName }) }}
        <br>
        <span 
          class="text-button"
          @click="confirmCancel"
          :class="{ 'disabled': !tenantAdminUser }"
        >
          <img src="../assets/cancel_icon.svg" class="button-icon" alt="Cancel Icon">
          <span>{{ $t('message.button_cancel_export') }}</span>
        </span>
        {{ $t('message.info_batch_export_not_admin_notice') }}
      </div>
      <div v-else-if="batchState===PROCESSING"> {{ $t('message.info_batch_export_processing') }} </div>
      <div v-else-if="batchState==='Error'"> {{ $t('message.info_batch_export_error') }} </div>
      <div v-else> {{ $t('message.info_batch_export_checking_status') }} </div>

      <div class="dialog-button-field">
        <el-button v-if="tenantAdminUser"
          class="dialog-ok-button"
          @click="sendRequest"
          :disabled="isDisable"
          v-t="'message.button_export'">
        </el-button>
      </div>
    
      <div>
      <!-- 注意書きエリア -->
        <div class="warning-box">
          <img src="../assets/icon_caution.svg" class="warning-icon" alt="Warning Icon">
          <span v-html="$t('message.info_batch_export_note')"></span>
        </div>
        <!-- ダウンロードリスト -->
        <el-table :data="displayFileList" style="width: 100%">
          <el-table-column prop="fileName" label="ファイル名" width="500" />
          <el-table-column prop="formattedDateTime" label="作成日時">
            <template #default="{ row }">
              {{ row.formattedDateTime || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="ダウンロード" width="150">
            <template #default="{ row }">
              <el-button v-if="tenantAdminUser" class="custom-button" @click="downloadFileInS3(row.key)">
                <img src="../assets/icon_download.svg" class="button-icon" alt="Download Icon">
                <span>{{ $t('message.action_download') }}</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    props: ['batchState', 'exportingCsvType', 'userDisplayName', 'tenantAdminUser'],

    data() {
        return {
            // Const
            NO_QUEUE: constants.BATCH_CSV_NO_QUEUE,
            IN_QUEUE: constants.BATCH_CSV_IN_QUEUE,
            PROCESSING: constants.BATCH_CSV_PROCESSING,

            typeItems: [
                { name: constants.CSV_USER , label: commonUtil.getMessageText(this.$i18n,"item_user")},
                { name: constants.CSV_GROUP , label: commonUtil.getMessageText(this.$i18n,"item_group")},
                { name: constants.CSV_USER_GROUP , label: commonUtil.getMessageText(this.$i18n,"title_userGroup")}
            ],
            disableButton: false,
            selectedAdvancedTabName: "export",
            showAdvancedImport: false,
            advancedStatus: '',
            progressMessage: '',
            selectedType: constants.CSV_USER,
            fileList: []
        };
    },

    computed: {
        isDisable() {
            switch (this.selectedAdvancedTabName) {
                case "import":
                    return this.advancedStatus !== 'success';
                case "export":
                  switch (this.batchState) {
                    case this.IN_QUEUE:
                    case this.PROCESSING:
                      return true;
                    case this.NO_QUEUE:
                      return this.disableButton;
                    default:
                      return true;
                  }
                default:
                    return true;
            }
        },
        isSelecterDisable() {
          switch (this.batchState) {
            case this.IN_QUEUE:
            case this.PROCESSING:
              this.selectedType = this.exportingCsvType;
              return true;
            case this.NO_QUEUE:
              return false;
            default:
             return true;
          }
        },
        titilLabel() {
          switch (this.selectedType) {
            case constants.CSV_USER:
                return commonUtil.getMessageText(this.$i18n,"item_user")
            case constants.CSV_GROUP:
              return commonUtil.getMessageText(this.$i18n,"item_group")
            case constants.CSV_USER_GROUP:
                return commonUtil.getMessageText(this.$i18n,"title_userGroup")
            }
        },
        displayName() {
          return this.userDisplayName;
        },
        displayFileList() {
          return this.fileList.map(file => {
            const fileName = this.extractFileName(file.objectKey);
            const rawDateTime = this.extractDateTime(fileName);
            return {
              key: file.objectKey,
              fileName: fileName,
              rawDateTime: rawDateTime,
              formattedDateTime: rawDateTime ? this.formatDate(rawDateTime) : "-" 
            }
          })
          .sort((a, b) => (b.rawDateTime || 0) - (a.rawDateTime || 0));
        }
    },

    watch: {
      'appData.csvProcessing': {
          handler(newVal) {
              this.disableButton = !!newVal;
          },
          immediate: true,
      },
      batchState(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchFiles('list_export');
        }
      }
    },

    mounted: function() {
      this.fetchFiles('list_export');
    },

    methods: {
        updateProgress(message) {
            this.progressMessage = message;
        },
        checkExportRequest() {
          this.$emit('check')
        },
        sendRequest() {
            if (this.fileList.length > 50) {
              commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n,"error_batch_export_extend_limit"));
              return
            }

            if (this.selectedAdvancedTabName === 'export') {
              this.$emit('export', this.selectedType)
            }
        },
        async deleteBatchInfoInS3(computeType) {
            try {
                const req = {
                    computeType: computeType,
                    type: this.selectedType,
                    locale: this.$i18n.locale
                }
                const res = await server.post("/csvbatchrequestcontroller", req);
                if (res.data.status === constants.STATUS_SUCCESS) {
                  if (computeType === "cancel_export") {
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n,"info_batch_export_cancel"));
                  } else {
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n,"info_batch_export_delete"));
                  }
                  this.checkExportRequest();
                } else {
                  if (req.computeType === "cancel_export") {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n,"error_batch_export_cancel"));
                  } else {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n,"error_batch_export_delete"));
                  }
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "deleteBatchInfoInS3", error);
            }
        },
        async fetchFiles(computeType) {
          try {
            const req = {
                computeType: computeType
            }
            const res = await server.post("/csvbatchrequestcontroller", req);
            if (res.data.status === constants.STATUS_SUCCESS) {
              this.fileList = res.data.resultFileInfos
            };
          } catch (error) {
            commonUtil.putExceptionErrorMessage(this, "fetchFiles", error);
          }
        },
        async downloadFileInS3(key) {
            try {
                const req = {
                    computeType: "get_export",
                    key: key
                }
                const res = await server.post("/csvbatchrequestcontroller", req);
                if (res.data.status === constants.STATUS_SUCCESS && res.data.url) {
                    const presignedUrl = res.data.url;
                    const link = document.createElement("a");
                    link.href = presignedUrl;
                    link.download = "";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n,"info_batch_export_download"));
                } else {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n,"info_batch_export_error"));
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "downloadFileInS3", error);
            }
        },
        extractFileName(objectKey) {
          const parts = objectKey.split("/");
          return parts.length > 0 ? parts[parts.length - 1] : objectKey;
        },
        extractDateTime(fileName) {
          const match = fileName.match(/buddycom_export_.+?_(\d{14})\.csv/);
          if (match) {
            return new Date(
              match[1].substring(0, 4),  // 年
              match[1].substring(4, 6) - 1, // 月
              match[1].substring(6, 8),  // 日
              match[1].substring(8, 10), // 時
              match[1].substring(10, 12), // 分
              match[1].substring(12, 14)  // 秒
            );
          }
          return null;
        },
        formatDate(date) {
          return date.toLocaleString("ja-JP", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
          });
        },
        confirmCancel() {
          if (!this.tenantAdminUser) return;

          this.$confirm(
            this.$t('message.info_batch_export_confirm'),
            this.$t('message.title_confirm'),
          {
            confirmButtonText: this.$t('message.button_yes'),
            cancelButtonText: this.$t('message.button_no'),
            type: 'warning',
          }).then(() => {
            this.deleteBatchInfoInS3('cancel_export');
          });
        },
    },
}
</script scoped>

<style scoped>
.warning-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fff3cd;
  color: #856404;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}

.warning-icon {
  width: 16px;
  height: 16px;
}

.text-button {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #d32f2f;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease, text-decoration 0.3s ease;
}

.text-button:hover {
  text-decoration: underline;
  color: #b71c1c;
}

.text-button.disabled {
  color: #b0b0b0;
  cursor: not-allowed;
  text-decoration: none;
}

.custom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  height: 36px;
  line-height: 1.2;
  box-sizing: border-box;
}

.custom-button:hover {
  background-color: #e6e6e6;
}

.button-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

.delete-button {
  background-color: #ff4d4f;
  color: white;
  border-color: #ff4d4f;
}

.delete-button:hover {
  background-color: #ff7875;
  border-color: #ff7875;
}
</style>
